import { injectGlobal } from 'styled-components';
import theme from './theme';

injectGlobal`
  @import url("https://use.typekit.net/nyw7zkf.css");

  @font-face {
    font-family: 'DINOT';
    src: url('/assets/fonts/DINOT-Light.woff2') format('woff2'),
        url('/assets/fonts/DINOT-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'DINOT';
    src: url('/assets/fonts/DINOT-Medium.woff2') format('woff2'),
        url('/assets/fonts/DINOT-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'DINOT';
    src: url('/assets/fonts/DINOT.woff2') format('woff2'),
        url('/assets/fonts/DINOT.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(60px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .fadeInUp {
    animation-name: fadeInUp;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html,
  body,
  #app {
    width: 100%;
    height: 100%;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-text-stroke: 0;
  }

  body {
    font-family: 'garamond-premier-pro';
  }

  a,
  button {
    outline: none;
    border: none;
    background: transparent;
    text-decoration: none;
    color: ${theme.colorPrimary};
  }

  main {
    text-align: center;
    width: 100%;
    height: 100%;
  }

  h1 {
    font-family: 'DINOT';
    font-size: 30px;
    color: ${theme.colorPrimary};
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
  }
  
`;



// WEBPACK FOOTER //
// ./src/styles/global.js